import {useCallback, useState} from 'react';
import qs from 'query-string';

const setQueryStringWithoutPageReload = qsValue => {
  const newurl = window.location.protocol + '//' + window.location.host + window.location.pathname + qsValue;

  window.history.pushState({path: newurl}, '', newurl);
};

const setQueryStringValue = (key, value, queryString = window.location.search) => {
  const values = qs.parse(queryString);
  const newQsValue = qs.stringify({...values, [key]: value});
  setQueryStringWithoutPageReload(`?${newQsValue}`);
};

const getQueryStringValue = (key, queryString = window.location.search) => {
  const values = qs.parse(queryString);
  return values[key];
};

/**
 * Essentially the same as React.useState however it saves the value to the url and initializes the value from it on refresh.
 * @param {String} key The query parameter name
 * @param {String} [initialValue] The value to initialize the variable to, only used if not provided in query params.
 * @return {*[]} The value and function to set value.
 */
function useQueryString(key, initialValue) {
  const [value, setValue] = useState(getQueryStringValue(key) || initialValue);
  const onSetValue = useCallback(newValue => {
    setValue(newValue);
    setQueryStringValue(key, newValue);
  }, [key]);
  return [value, onSetValue];
}

export default useQueryString;
